<template>
	<svg :class="classes" width="176" height="48" viewBox="0 0 176 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			class="duoToneTeamingWordLogo__Path"
			d="M175.263 11.4764V37.7131C175.263 44.2974 171.108 48 163.619 48C159.933 48 156.281 47.0953 153.382 45.5037L155.326 41.6C158.224 43.0911 160.771 43.7948 163.468 43.7948C167.908 43.7948 170.253 41.7005 170.253 37.6963V34.8482C168.109 36.5906 165.462 37.5456 162.664 37.5456C155.527 37.5456 149.881 31.799 149.881 24.511C149.881 17.223 155.527 11.4764 162.764 11.4764C165.512 11.4764 168.109 12.3812 170.304 14.023V11.4764H175.263ZM122.086 11.4764V37.3613H117.093V11.4764H122.086ZM137.717 11.4262C143.564 11.4262 147.669 15.4639 147.669 21.378V37.3613H142.676V22.2157C142.676 18.2115 140.23 15.7654 136.377 15.7654C133.68 15.7654 131.468 16.9215 130.077 19.066V37.3613H125.085V11.4764H130.077V14.4754C132.071 12.4817 134.668 11.4262 137.717 11.4262ZM72.1424 11.4764V37.3613H67.1665V34.7309C65.022 36.4733 62.3916 37.3613 59.6105 37.3613C52.5068 37.3613 46.8942 31.6984 46.8942 24.444C46.8942 17.1895 52.5068 11.4764 59.711 11.4764C62.4419 11.4764 65.022 12.3644 67.2168 14.0063V11.4764H72.1424ZM85.5623 11.4262C91.7445 11.4262 96.7874 16.4524 96.7874 22.6513V37.3613H91.7948V22.6513C91.7948 19.2168 88.9969 16.4188 85.5623 16.4188C82.1277 16.4188 79.3298 19.2168 79.3298 22.6513V37.3613H74.3372V22.6513C74.3372 16.4524 79.3801 11.4262 85.5623 11.4262ZM10.3372 3.75288V11.4597H17.8429V15.6482H10.3204V29.4534C10.3204 32.0503 11.3759 33.0052 14.0733 33.0052C15.4806 33.0052 16.4691 32.8545 17.7257 32.4021V36.5906C16.3853 37.0429 14.4754 37.3445 12.9843 37.3445C8.04189 37.3445 5.39476 34.9822 5.39476 30.5927V15.6482H0V11.4597H5.39476V4.95916L10.3372 3.75288ZM32.5696 11.4764C39.4555 11.4764 44.666 17.1728 44.666 24.5445V25.9686H24.9131C25.6168 30.1403 29.0513 33.1393 33.3738 33.1393C35.8199 33.1393 38.1319 32.3016 39.7068 30.9277L42.8398 34.044C39.9414 36.289 36.8921 37.3278 33.156 37.3278C25.7843 37.3278 20.0377 31.6817 20.0377 24.3602C20.0377 17.1225 25.533 11.4764 32.5696 11.4764ZM163.267 15.8157C158.475 15.8157 154.773 19.6188 154.773 24.511C154.773 29.4031 158.475 33.2063 163.267 33.2063C166.149 33.2063 168.612 32.1508 170.253 30.2576V18.7644C168.662 16.9215 166.115 15.8157 163.267 15.8157ZM60.2136 15.799C55.4387 15.799 51.7696 19.5686 51.7696 24.444C51.7696 29.3194 55.4387 33.089 60.2136 33.089C63.0953 33.089 65.5246 32.0503 67.1665 30.1571V18.7309C65.5749 16.888 63.045 15.799 60.2136 15.799ZM32.4691 15.5979C28.6827 15.5979 25.6838 18.2953 24.9466 22.2827H39.7906C39.0534 18.4461 36.1047 15.5979 32.4691 15.5979ZM85.5288 0C88.1424 0 90.3037 2.16126 90.3037 4.77487C90.3037 7.38848 88.1424 9.54974 85.5288 9.54974C82.9152 9.54974 80.8377 7.38848 80.8377 4.77487C80.8377 2.16126 82.9152 0 85.5288 0Z"
		/>
		<path
			class="duoToneTeamingWordLogo__Path"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M103.003 11.4262C109.202 11.4262 114.228 16.4524 114.228 22.6513V37.3613H109.236V22.6513C109.236 19.2168 106.438 16.4188 103.003 16.4188C99.5687 16.4188 96.7707 19.2168 96.7707 22.6513V37.3613H91.7781V22.6513C91.7781 16.4524 96.821 11.4262 103.003 11.4262ZM102.97 0C105.583 0 107.745 2.16126 107.745 4.77487C107.745 7.38848 105.583 9.54974 102.97 9.54974C100.356 9.54974 98.2786 7.38848 98.2786 4.77487C98.2786 2.16126 100.356 0 102.97 0Z"
		/>
	</svg>
</template>

<script>
export default {
	name: "DuoToneTeamingWordLogo",
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"teaming-letter-logo": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>


<style lang="scss" scoped>
.duoToneTeamingWordLogo__Path {
	&:first-of-type {
		fill: $duo-tone-teaming-word-color1;
	}

	&:last-of-type {
		fill: $duo-tone-teaming-word-color2;
	}
}
</style>
